// Shared microphone-error classification. Surfaces the real cause instead of a
// bare "TypeError", and logs the full error for debugging (NFR-6 friendly).

import { toast } from './store';

export function classifyMicError(e: unknown): string {
  const err = e as { name?: string; message?: string };
  const name = err?.name ?? '';
  const msg = err?.message ?? '';

  // Non-secure context: navigator.mediaDevices is undefined.
  if (typeof navigator !== 'undefined' && !navigator.mediaDevices) {
    return '麦克风不可用：当前为非安全上下文(非 HTTPS/localhost)。请用 localhost 打开，或通过 HTTPS 部署。';
  }
  if (name === 'TypeError' && /getUserMedia|mediaDevices|undefined/i.test(msg)) {
    return '麦克风不可用：浏览器未提供媒体设备 API(可能为非安全上下文)。请用 localhost 或 HTTPS 打开。';
  }
  if (name === 'NotAllowedError' || name === 'PermissionDeniedError') {
    return 'permission'; // caller shows guidance modal
  }
  if (name === 'NotFoundError' || name === 'DevicesNotFoundError') {
    return '未检测到麦克风设备，请检查设备连接。';
  }
  if (name === 'NotReadableError' || name === 'TrackStartError') {
    return '麦克风被其他程序占用，请关闭后重试。';
  }
  if (name === 'OverconstrainedError') {
    return '麦克风不满足约束条件，请更换设备或重试。';
  }
  return `麦克风启动失败：${name || '未知错误'}${msg ? ' — ' + msg : ''}`;
}

// Returns true if the error is a permission denial (caller may show a modal).
export function showMicError(e: unknown): boolean {
  console.error('[AudioEngine] mic start failed:', e);
  const msg = classifyMicError(e);
  if (msg === 'permission') {
    return true; // caller handles guidance modal
  }
  toast(msg, 4500);
  return false;
}

import { el } from './components';

// Permission-denial guidance modal (spec E-6). Shared by all pages.
export function showPermissionGuidance(): void {
  const close = el('button', { class: 'primary', text: '我知道了' });
  const modal = el('div', { class: 'modal' }, [
    el('h2', { text: '麦克风权限被拒绝' }),
    el('p', { class: 'muted', text: '请在浏览器地址栏点击锁形/音形图标，将麦克风权限改为"允许"后刷新页面。' }),
    el('p', { class: 'tiny muted', text: 'iOS Safari：设置 → Safari → 麦克风 → 允许。微信浏览器需在页面右上角 ··· 中授权。' }),
    el('div', { class: 'row', style: 'justify-content:flex-end;margin-top:12px' }, [close]),
  ]);
  const bg = el('div', { class: 'modal-bg' }, [modal]);
  close.onclick = () => bg.remove();
  document.body.appendChild(bg);
}
